import React, { useEffect, useState } from "react";
import api from "api";
import Swal from "sweetalert2";
import { formatPrice } from "utils";

export default function PaymentLinkForm({
  orderId,
  orderBalance,
  defaultRecipient = {},
  onSuccess,
  onCancel,
}) {
  const [form, setForm] = useState({
    recipientFirstname: "",
    recipientLastname: "",
    recipientEmail: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setForm({
      recipientFirstname: defaultRecipient.recipientFirstname || "",
      recipientLastname: defaultRecipient.recipientLastname || "",
      recipientEmail: defaultRecipient.recipientEmail || "",
    });
    setErrors({});
  }, [defaultRecipient]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setErrors({});
      api.handleError = false;

      const res = await api.post(
        `/orders/${orderId}/payment-link`,
        form
      );

      Swal.fire({
        title: "Lien envoyé",
        text: "Le lien de paiement a été envoyé avec succès.",
      });

      onSuccess && onSuccess(res.data);

    } catch (e) {
      if (e.response?.status === 422) {
        let backendErrors = [];

        try {
          backendErrors = JSON.parse(
            e.response.data.error.message
          );
        } catch {
          backendErrors = [];
        }

        const formatted = {};
        backendErrors.forEach(({ field, reason }) => {
          formatted[field] = reason;
        });

        setErrors(formatted);
        return;
      }

      Swal.fire({
        title: "Erreur",
        text:
          e.response?.data?.error?.message ||
          "Impossible de générer le lien de paiement.",
      });
    } finally {
      setLoading(false);
    }
  };

  const isDisabled =
    loading ||
    !form.recipientFirstname ||
    !form.recipientLastname ||
    !form.recipientEmail;

  return (
    <>


      <p className="fw-bold small mb-2">
        Destinataire du lien :
      </p>

      <div className="row">
        <div className="col-md-6 mb-3">
          <input
            type="text"
            name="recipientFirstname"
            placeholder="Prénom"
            className={`form-control form-control-sm ${errors.recipientFirstname ? "is-invalid" : ""}`}
            value={form.recipientFirstname}
            onChange={handleChange}
          />
          {errors.recipientFirstname && (
            <div className="invalid-feedback">
              {errors.recipientFirstname}
            </div>
          )}
        </div>

        <div className="col-md-6 mb-3">
          <input
            type="text"
            name="recipientLastname"
            placeholder="Nom"
            className={`form-control form-control-sm ${errors.recipientLastname ? "is-invalid" : ""}`}
            value={form.recipientLastname}
            onChange={handleChange}
          />
          {errors.recipientLastname && (
            <div className="invalid-feedback">
              {errors.recipientLastname}
            </div>
          )}
        </div>
      </div>

      <div className="mb-3">
        <input
          type="email"
          name="recipientEmail"
          placeholder="Adresse email"
          className={`form-control form-control-sm ${errors.recipientEmail ? "is-invalid" : ""}`}
          value={form.recipientEmail}
          onChange={handleChange}
        />
        {errors.recipientEmail && (
          <div className="invalid-feedback">
            {errors.recipientEmail}
          </div>
        )}
      </div>

      <div className="d-flex justify-content-end gap-2">
        {onCancel && (
          <button
            className="btn btn-sm btn-outline-secondary  rounded-pill"
            onClick={onCancel}
            disabled={loading}
          >
            Annuler
          </button>
        )}

        <button
          className="btn btn-primary btn-sm rounded-pill"
          disabled={isDisabled}
          onClick={handleSubmit}
        >
          {loading ? "Envoi..." : "Envoyer le lien"}
        </button>
      </div>
    </>
  );
}